import 'settings-side-panel/styles.css';

import type { TOC } from '@ember/component/template-only';
import GeneralPageMain from 'lumen/components/general/page/main';
import SettingsDrawerSidebar from 'lumen/components/settings/drawer/sidebar';
import hasFeatureToggle from 'lumen/helpers/has-feature-toggle';
import mountReact from 'lumen/modifiers/mount-react';
import { FEATURE_TOGGLES } from 'lumen/utils/constants/feature-toggle-constants';
import { HotelSettingsSidePanel } from 'settings-side-panel';

<template>
  <GeneralPageMain class="navbar-settings">
    {{#if (hasFeatureToggle FEATURE_TOGGLES.SETTINGS_THEME_REACT)}}
      <div class="flex" {{mountReact HotelSettingsSidePanel}}></div>
    {{else}}
      <SettingsDrawerSidebar />
    {{/if}}
    <div class="content-wrapper main-content flex flex-col gap-0">
      {{outlet}}
    </div>
  </GeneralPageMain>
</template> satisfies TOC<object>;
